import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconCustomize = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 26"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M8.307 11.422l-1.048-1.044A4.543 4.543 0 011.193 4.33l1.425 1.42a1.514 1.514 0 102.144-2.137l-1.424-1.42A4.542 4.542 0 019.4 8.24l.97.967M15.319 14.136l1.422 1.418a4.543 4.543 0 016.066 6.046l-1.425-1.42a1.514 1.514 0 00-2.144 2.138l1.424 1.42a4.542 4.542 0 01-6.062-6.046l-1.422-1.418",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M1.445 23.6v0a2.233 2.233 0 010-3.167l4.695-4.686a.75.75 0 011.059 0l2.118 2.11a.746.746 0 010 1.057L4.621 23.6a2.25 2.25 0 01-3.176 0zM16.586 2.188l6.22 6.2a1.49 1.49 0 010 2.11l-2.116 2.114a1.5 1.5 0 01-2.118 0l-6.221-6.2a1.489 1.489 0 010-2.111l2.117-2.111a1.5 1.5 0 012.118-.002z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.527 9.577l-7.369 7.126",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconCustomize.displayName = "IconCustomize";

export { IconCustomize };
